import Chip from '@components/v2/ui/Chip/Chip';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { PaymentMethod } from '../../../../../../../../../payment-method/payment-method.types';
import { useTranslation } from '../../../../../../../../../translation/TranslationContext';
import useOrderConditionPaymentMethodOption from './hooks/useOrderConditionPaymentMethodOption';

interface OrderConditionPaymentMethodOptionProps {
  paymentMethod: PaymentMethod;
}

const OrderConditionPaymentMethodOption = ({
  paymentMethod,
}: OrderConditionPaymentMethodOptionProps) => {
  const { translate } = useTranslation();
  const { suffix, isPolicyVisible, policyLabel, hiddenPolicyLabels } =
    useOrderConditionPaymentMethodOption(paymentMethod);

  return (
    <Stack sx={{ flex: 1, minWidth: 0, gap: 0.5 }}>
      <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
        <Typography variant="body1" noWrap>
          {paymentMethod.name}
        </Typography>

        {suffix && <Chip label={suffix} size="extraSmall" sx={{ flexShrink: 0 }} />}
      </Stack>

      {isPolicyVisible && (
        <Stack
          direction="row"
          sx={{ alignItems: 'center', justifyContent: 'space-between', gap: 1 }}
        >
          <Typography variant="micro1" color="text.secondary" noWrap>
            {policyLabel}
          </Typography>

          {hiddenPolicyLabels.length > 0 && (
            <Tooltip
              placement="right"
              tabIndex={-1}
              TooltipContent={
                <Stack sx={{ gap: 0.5 }}>
                  <Typography variant="subtitle2" color="inherit">
                    {translate(LangEnum.GLOBAL_ANOTHER_OPTIONS)}
                  </Typography>

                  {hiddenPolicyLabels.map((label, index) => (
                    <Typography key={label} variant="body2" color="inherit">
                      • {label}
                      {index < hiddenPolicyLabels.length - 1 && ` ${translate(LangEnum.GLOBAL_OR)}`}
                    </Typography>
                  ))}
                </Stack>
              }
            >
              <Chip label={`+${hiddenPolicyLabels.length}`} size="extraSmall" />
            </Tooltip>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default OrderConditionPaymentMethodOption;
